import { and, isStringControl, JsonFormsRendererRegistryEntry, rankWith, optionIs } from '@jsonforms/core';
import controlRenderer from './StringControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(10, and(isStringControl, optionIs('version', 'v2'))),
};
